import api from "./admin_api_global";

const ok  = (r) => ({ status: r.status, data: r.data });
const err = (e) => ({ status: e.response?.status || 500, message: e.response?.data?.message || "Failed" });

export const fetchTemplates    = ()        => api.get("/admin/timetable/templates").then(ok).catch(err);
export const createTemplate    = (data)    => api.post("/admin/timetable/templates", data).then(ok).catch(err);
export const deleteTemplate    = (id)      => api.delete(`/admin/timetable/templates/${id}`).then(ok).catch(err);
